/**
 * 排出別品目単価
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

//driver/api/v1/masters/search/emissions//6/sales_item_prices
const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/emissions`
const search_emission_sales_item_price_detail = {
  namespaced: true,
  actions: {
    /**
     * 排出別売上品目単価一覧の取得
     * @param dispatch
     * @param commit
     * @param state
     * @param emission_id
     * @param reference_date
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { emission_id}) {
      const api_path = `${API_PATH}/${emission_id}/sales_item_price_details`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
  },
  mutations: {},
}

export default search_emission_sales_item_price_detail

